import { lazyLoad } from 'unlazy';
import Parallax from './components/parallax';
import Tabs from './components/tabs';
import Accordion from './components/accordion';
import Lightbox from './components/lightbox';
import modals from './components/modals';
import counter from './components/counter';
import { Reinvestment, Distribution } from './components/calculator';

console.log('hello');


import { Navigation } from 'swiper/modules';

import { featuredSlider, homeBanner, teamSlider, timelineSlider, supportSlider } from './components/sliders';

// async function loadPageModule(moduleName) {
//     try {
//         const module = await import(`./pages/${moduleName}.js`);
//         console.log(`${moduleName} module loaded`);
//     } catch (err) {
//         console.error(`Failed to load ${moduleName} module`, err);
//     }
// }

let resizeTimer;

window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 768) {
            location.reload();
        }
    }, 200);
});

(() => {
    const page = document.body.dataset.page;
    if (page) {
        // loadPageModule(page);
        console.log(`Loading ${page} page...`);
    }
    // lazyLoad('img[data-srcset]')
	document.querySelectorAll('[data-parallax]').forEach((container) => {
		new Parallax(container);
	});
    
	new Tabs('[data-tabs]');
    document.querySelectorAll('[data-accordion]').forEach((el) => {
        new Accordion(el);
    });

    new Lightbox('[data-lightbox]');
})();

let homeNav = () => {
    // let homepage = document.querySelector('body').dataset.page-type;
    let homepage = document.querySelector('body').getAttribute('data-page-type') == 'home';

    if (homepage) {
        let nav = document.querySelector('header');
        if (nav) {
            let navHeight = nav.offsetHeight;
            nav.classList.add('homeNav');
        }
    }
}


// // banner style 3
const findContainerLeftOffset = () => {
    const firstContainer = document.querySelector('.container');
    if (firstContainer) {
        let offsetLeft = firstContainer.offsetLeft;
        let paddingLeft = getComputedStyle(firstContainer).paddingLeft.replace('px', '');

        offsetLeft += parseInt(paddingLeft);

        document.documentElement.style.setProperty('--container-offset', `${offsetLeft}px`);

        if (window.innerWidth > 1199) {
            const containerLeftOffset = document.querySelectorAll('.containerLeftOffset');
            const viewportWidth = document.querySelector('body').clientWidth; // 100vw equivalent

            containerLeftOffset.forEach((element) => {
                const newWidth = `${viewportWidth - offsetLeft}px`;

                // console.log(newWidth, offsetLeft, viewportWidth, paddingLeft);

                // Apply the calculated width
                element.style.width = newWidth;
            });
        }
    }
};

const offCanvas = () => {
    const triggerButtons = document.querySelectorAll('[data-offcanvas-trigger]');
    const containers = document.querySelectorAll('[data-offcanvas-container]');

    containers.forEach(container => {
        container.classList.add('duration-300');

        const submenuItems = container.querySelectorAll('li.has-submenu');

        submenuItems.forEach(item => {
            // Add a click event to toggle submenu
            item.querySelector('div').addEventListener('click', () => {
                submenuItems.forEach(item2 => { 
                    // check if item2 and item are not the same
                    if (item !== item2) {
                        item2.classList.remove('show');
                    } else {
                        item2.classList.toggle('show');
                    }
                });
            });

            let childMenuItems = item.querySelectorAll('li.dropdown');

            childMenuItems.forEach(item => {
                item.querySelector('div').addEventListener('click', () => {
                    childMenuItems.forEach(item2 => { 
                        // check if item2 and item are not the same
                        if (item !== item2) {
                            item2.classList.remove('show');
                        } else {
                            item2.classList.toggle('show');
                        }
                    });
                });
            })
        });
    })

    triggerButtons.forEach(button => {
        button.addEventListener('click', () => {
            const target = button.getAttribute('data-offcanvas-trigger');
            const container = document.querySelector(`[data-offcanvas-container="${target}"]`);

            if (container) {
                container.classList.toggle('translate-x-full');
                container.classList.toggle('translate-x-0');

                //toggle scroll lock
                document.body.classList.toggle('overflow-hidden');
            }
        });
    });
}

const teamModal = () => {
    const teamOpen = document.querySelectorAll('.teamOpen');
    const teamBox = document.querySelectorAll('.teamBox');

    teamOpen.forEach(item => {
        item.addEventListener('click', (e) => {
            // e.preventDefault();
            let teamId = item.getAttribute('data-team-open');

            teamBox.forEach(box => {
                box.classList.add('hidden');
            });

            const thisBox = document.getElementById(teamId);

            thisBox.classList.remove('hidden');
        });
    });
    teamBox.forEach(box => {

        box.querySelector('[data-team-close]').addEventListener('click', () => {
            box.classList.add('hidden');
        });
    });

    // get url #
    const hash = window.location.hash;
    if (hash) {
        const teamBox = document.getElementById(hash.slice(1)+'-box');
        if (teamBox) {
            teamBox.classList.remove('hidden');
        }
    }
}

const tabs = () => {
    const tabOpen = document.querySelectorAll('.tabOpen');
    const tabBox = document.querySelectorAll('.tabBox');

    tabOpen.forEach(item => {
        item.addEventListener('click', (e) => {
            // e.preventDefault();
            let tabId = item.getAttribute('data-tab-open');

            tabOpen.forEach(item => {
                item.classList.remove('active');
            });

            item.classList.add('active');

            console.log("🚀 ~ item.addEventListener ~ tabId:", tabId)


            tabBox.forEach(box => {
                box.classList.add('hidden');
            });

            const thisBox = document.getElementById('tab-'+tabId);

            thisBox.classList.remove('hidden');
        });
    });
}

const bannerGap = () => {

    if (window.innerWidth < 1024) {
        return;
    }
    setTimeout(() => {
        
        const banner = document.querySelector('.gapBottom');

        if (!banner) {return} 
        const imgHeight = banner.querySelector('.image').getBoundingClientRect().height;
    
        console.log(imgHeight);
        banner.style.paddingBottom = `${imgHeight/2}px`;
    
        // banner's next sibling
        const nextSibling = banner.nextElementSibling;
        nextSibling.style.marginTop = `${imgHeight/2}px`;
    }, 500)
}

// on doc ready
window.addEventListener('DOMContentLoaded', () => {

    lazyLoad('img[data-lazy-load]')

    featuredSlider();


    bannerGap();

    homeNav();

    findContainerLeftOffset();

    homeBanner();

    timelineSlider();

    teamSlider();

    supportSlider();

    offCanvas();

    teamModal();

    tabs();

    modals();
    counter();

    // new Reinvestment();
    // new Distribution();
});

window.addEventListener('resize', () => {
    findContainerLeftOffset();

    bannerGap();
});

document.querySelectorAll('[data-reinvestment-rate]').forEach(inputContainer => {
    const panelClass = inputContainer.closest('[role="tabpanel"]')?.className.match(/calculator-panel-\d+/);
    const outputContainer = panelClass 
        ? inputContainer.closest('[role="tabpanel"]')?.parentElement?.nextElementSibling?.querySelector('[class*="' + panelClass[0] + '"]')
        : null;
    new Reinvestment(inputContainer, outputContainer);
});
 
// For Distribution calculators  
document.querySelectorAll('[data-distribution-rate]').forEach(inputContainer => {
    const panelClass = inputContainer.closest('[role="tabpanel"]')?.className.match(/calculator-panel-\d+/);
    const outputContainer = panelClass 
        ? inputContainer.closest('[role="tabpanel"]')?.parentElement?.nextElementSibling?.querySelector('[class*="' + panelClass[0] + '"]')
        : null;
    new Distribution(inputContainer, outputContainer);
});


import 'htmx.org';

document.body.addEventListener('htmx:afterSwap', (event) => {
    lazyLoad('img[data-lazy-load]')
});




// const setFooterHeight = () => {
//     if (window.innerWidth > 1199) {
//         setTimeout(() => {
//             let footerHeight = document.querySelector('footer').offsetHeight;
//             document.querySelector('.sticky-footer').style.height = `${footerHeight}px`;
//         }, 500);
//     }
// }

// const navDropDown = () => {
//     const navItems = document.querySelectorAll('.dropdown');

//     navItems.forEach(item => {
//         let children = item.querySelector('.dropdown-menu');
//         // hover remove hidden class
//         item.addEventListener('mouseover', () => {
//             children.classList.remove('hidden');
//         });
//         item.addEventListener('mouseout', () => {
//             children.classList.add('hidden');
//         });

//     });
// }

// navDropDown();




window.addEventListener('load', () => {
    const slider = document.querySelector('.featuredSliderContainer');
    if (!slider) return;

    const height = slider.offsetHeight; // gets height in px
    console.log('Slider height:', height);

    // Example: apply it dynamically like in your Sass
    const pullUp = document.querySelector('.pullUp');
    if (pullUp) {

        const prevSibling = pullUp.previousElementSibling;

        if (prevSibling) {
            // Get the computed background style
            const computedStyle = window.getComputedStyle(prevSibling);
            const background = computedStyle.background || computedStyle.backgroundColor;

            // Apply it to pullUp
            pullUp.style.background = background;

            console.log('Applied background to pullUp:', background);
        } else {
            console.warn('No previous sibling found for .pullUp');
        }


        pullUp.style.paddingTop = `${height / 2}px`;

        const nextDiv = pullUp.nextElementSibling;
        if (nextDiv) {
            nextDiv.style.position = 'absolute';
            nextDiv.style.paddingTop = '0';

            const nextNextDiv = nextDiv.nextElementSibling;
            if (nextNextDiv) {
                nextNextDiv.style.paddingTop = `${height / 2}px`;
            }

            nextDiv.style.transform = `translateY(${-height / 2}px)`;
        }
    }
});